import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/provider";
import theme from "theme/theme.js";
import { RecoilRoot } from "recoil";
import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import { PrivateRoute } from "auth/PrivateRoute";
import { AuthInitializer } from "auth/AuthInitializer";
import './assets/css/styles.scss';

ReactDOM.render(
  <RecoilRoot>
    <ChakraProvider theme={theme} resetCss={false} position="relative">
      <HashRouter>
        <AuthInitializer>
          <Switch>
            <Route path={`/auth`} component={AuthLayout} />
            <PrivateRoute path={`/admin`} component={AdminLayout} />
            <Redirect from={`/`} to="/admin/booking/create" />
          </Switch>
        </AuthInitializer>
      </HashRouter>
    </ChakraProvider>
  </RecoilRoot>,
  document.getElementById("root")
);
